import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "text-grey-7" }

import { computed } from 'vue'
import { useFormatDate } from '../composables/formatDate'
import { useQuasar } from 'quasar'
import sanitizeHtml from 'sanitize-html'

export default /*#__PURE__*/_defineComponent({
  __name: 'MessageInboxItem',
  props: {
    sent: { type: Boolean, default: false },
    priority: { type: Boolean },
    from: {},
    to: {},
    subject: {},
    body: {},
    date: {},
    read: { type: Boolean },
    attachment: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

/**Renders time if today, date if previous day */
const renderDate = computed(() => {
  if (
    new Date().getDate() == props.date.getDate() &&
    new Date().getMonth() == props.date.getMonth() &&
    new Date().getFullYear() == props.date.getFullYear()
  ) {
    //render time
    return `${useFormatDate(props.date).time()}`
  } else {
    return `${useFormatDate(props.date).month({ month: 'short' })} ${useFormatDate(
      props.date
    ).day()}`
  }
})
const unread = computed(() => !props.read)
const bodySanitized = computed(() => {
  return sanitizeHtml(props.body, {
    allowedTags: [],
  })
    .replaceAll('&gt;', '>')
    .replaceAll('&lt;', '<')
})
//for ripple.
const $q = useQuasar()
__expose({ $q })

return (_ctx: any,_cache: any) => {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item = _resolveComponent("q-item")!
  const _directive_ripple = _resolveDirective("ripple")!

  return _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_item_section, { side: "" }, {
        default: _withCtx(() => [
          _createElementVNode("span", {
            class: _normalizeClass([unread.value ? 'text-weight-bold' : '', "text-black tw-w-36 tw-truncate"])
          }, _toDisplayString(_ctx.sent ? `To: ${_ctx.to?.name}` : _ctx.from?.name), 3)
        ]),
        _: 1
      }),
      _createVNode(_component_q_item_section, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_label, { lines: "1" }, {
            default: _withCtx(() => [
              (_ctx.priority)
                ? (_openBlock(), _createBlock(_component_q_avatar, {
                    key: 0,
                    rounded: "",
                    color: "warning",
                    size: "xs",
                    "text-color": "black",
                    icon: "priority_high",
                    class: "q-mr-xs",
                    "font-size": ".8rem"
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: _normalizeClass([unread.value ? 'text-weight-bold' : '', "text-black"])
              }, _toDisplayString(_ctx.subject), 3),
              _createElementVNode("span", _hoisted_1, " - " + _toDisplayString(bodySanitized.value.replaceAll('>', '>').replaceAll('<', '<')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.attachment)
        ? (_openBlock(), _createBlock(_component_q_item_section, {
            key: 0,
            side: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_icon, { name: "attachment" })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_q_item_section, { side: "" }, {
        default: _withCtx(() => [
          _createElementVNode("span", {
            class: _normalizeClass([unread.value ? 'text-weight-bold' : '', "text-black text-right tw-w-16"])
          }, _toDisplayString(renderDate.value), 3)
        ]),
        _: 1
      })
    ]),
    _: 1
  })), [
    [_directive_ripple]
  ])
}
}

})